import { ResourcefulReducer } from '../../util';
import EntityTypeModel from '../models/entity_type_model';

const EntityTypeReducer = new ResourcefulReducer('entity_types', EntityTypeModel);

export default EntityTypeReducer;
